export default {
  en: {
    submit: 'Submit',
    cancel: 'Cancel',
    add_a_comment: 'Your comment...',
    add_a_reply: 'Your reply...',
  },
};
